/* Marbly theme interactions */
(function () {
  'use strict';
  var d = document, w = window;
  var T = w.MBTheme || { routes: {}, strings: {} };
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var mq = function (q) { return w.matchMedia(q).matches; };
  var root = (T.routes.root || '/').replace(/\/$/, '');

  /* ---------------- header ---------------- */
  var header = $('[data-mb-header]');
  if (header) {
    var transparent = header.getAttribute('data-transparent') === 'true';
    var onScroll = function () {
      var fixed = (w.scrollY || w.pageYOffset) > 0;
      header.classList.toggle('is-fixed', fixed);
      if (transparent) header.classList.toggle('mb-header--transparent', !fixed);
    };
    w.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    $$('[data-mb-navitem]', header).forEach(function (item) {
      var t;
      item.addEventListener('mouseenter', function () { clearTimeout(t); item.classList.add('is-open'); header.classList.add('is-hovered'); });
      item.addEventListener('mouseleave', function () { t = setTimeout(function () { item.classList.remove('is-open'); if (!$('.is-open[data-mb-navitem]', header)) header.classList.remove('is-hovered'); }, 80); });
      item.addEventListener('focusin', function () { item.classList.add('is-open'); header.classList.add('is-hovered'); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); header.classList.remove('is-hovered'); } });
    });
  }

  /* ---------------- search popdown + predictive search ---------------- */
  var search = $('[data-mb-search]');
  var searchInput = search && $('[data-mb-search-input]', search);
  var searchResults = search && $('[data-mb-search-results]', search);
  var openSearch = function () {
    if (!search) { w.location.href = T.routes.search || '/search'; return; }
    search.classList.add('is-open'); if (header) header.classList.add('is-searching');
    setTimeout(function () { searchInput && searchInput.focus(); }, 50);
  };
  var closeSearch = function () { if (!search) return; search.classList.remove('is-open'); if (header) header.classList.remove('is-searching'); };
  if (search) {
    $('[data-mb-search-close]', search).addEventListener('click', closeSearch);
    var st;
    searchInput.addEventListener('input', function () {
      clearTimeout(st);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; searchResults.classList.remove('has-results'); return; }
      st = setTimeout(function () {
        fetch((T.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { searchResults.innerHTML = ''; searchResults.classList.remove('has-results'); return; }
            searchResults.innerHTML = '<div class="mb-search__grid">' + items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '';
              return '<a class="mb-search__item" href="' + p.url + '"><span>' + img + '</span>' + p.title + '<br>' + (p.price ? p.price : '') + '</a>';
            }).join('') + '</div><a class="mb-btn-text mb-search__all" href="' + (T.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '">' + (T.strings.viewAll || 'View all results') + '</a>';
            searchResults.classList.add('has-results');
          }).catch(function () {});
      }, 250);
    });
  }
  w.MB = w.MB || {};
  w.MB.openSearch = openSearch;

  /* ---------------- announcement slider ---------------- */
  $$('[data-mb-announce]').forEach(function (bar) {
    var slides = $$('.mb-announce__slide', bar);
    if (slides.length < 2) return;
    var i = 0, ms = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    setInterval(function () {
      var next = (i + 1) % slides.length;
      slides.forEach(function (s, k) {
        if (k === i) s.style.transform = 'translateX(-100%)';
        else if (k === next) { s.style.transition = 'none'; s.style.transform = 'translateX(100%)'; void s.offsetWidth; s.style.transition = ''; s.style.transform = 'translateX(0%)'; }
        else s.style.transform = 'translateX(100%)';
      });
      i = next;
    }, ms);
  });

  /* ---------------- hero slideshow ---------------- */
  $$('[data-mb-hero]').forEach(function (hero) {
    var slides = $$('.mb-hero__slide', hero);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () { slides[i].classList.remove('is-active'); i = (i + 1) % slides.length; slides[i].classList.add('is-active'); }, 6000);
  });

  /* ---------------- drawers ---------------- */
  var overlay = $('[data-mb-overlay]');
  var lastFocus = null;
  var openDrawer = function (name) {
    var dr = $('[data-mb-drawer="' + name + '"]');
    if (!dr) return false;
    lastFocus = d.activeElement;
    $$('.mb-drawer.is-open').forEach(function (x) { x.classList.remove('is-open'); });
    closeSearch();
    dr.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    d.documentElement.style.overflow = 'hidden';
    var f = $('button, a, input', dr); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
    return true;
  };
  var closeDrawers = function () {
    $$('.mb-drawer.is-open').forEach(function (x) { x.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    d.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  w.MB.openDrawer = openDrawer; w.MB.closeDrawers = closeDrawers;

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mb-open]');
    if (t) {
      var name = t.getAttribute('data-mb-open');
      if (name === 'search') { e.preventDefault(); if (search && search.classList.contains('is-open')) closeSearch(); else openSearch(); return; }
      if (name === 'cart' && mq('(max-width:0px)')) return;
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-mb-close]') || e.target === overlay) { e.preventDefault(); closeDrawers(); return; }

    var mt = e.target.closest('.mb-mnav__toggle');
    if (mt) { e.preventDefault(); mt.closest('.mb-mnav__item').classList.toggle('is-open'); return; }

    var ft = e.target.closest('.mb-footer__mtitle');
    if (ft) { if (mq('(max-width:767px)')) { e.preventDefault(); ft.closest('.mb-footer__block').classList.toggle('is-open'); } return; }

    var acc = e.target.closest('.mb-pacc__title, .mb-faq__q, .mb-cwidget__title, .mb-accs__title');
    if (acc) {
      e.preventDefault();
      var box = acc.closest('.mb-pacc, .mb-faq__item, .mb-cwidget, .mb-accs__item');
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      acc.setAttribute('aria-expanded', open);
      if (open && w.MB.setupEllipsis) w.MB.setupEllipsis($('[data-mb-ellipsis]', box));
      return;
    }

    var eb = e.target.closest('.mb-ellipsis__btn');
    if (eb) {
      e.preventDefault();
      var el = eb.closest('[data-mb-ellipsis]'), eopen = !el.classList.contains('is-open');
      el.classList.toggle('is-open', eopen);
      el.style.height = eopen ? ($('.mb-ellipsis__content', el).scrollHeight + $('.mb-ellipsis__actions', el).offsetHeight) + 'px' : '175px';
      return;
    }

    var rm = e.target.closest('[data-mb-readmore]');
    if (rm) {
      e.preventDefault();
      var more = rm.closest('.mb-seo__body').querySelector('.mb-seo__more');
      if (more) { more.hidden = !more.hidden; rm.textContent = more.hidden ? (rm.getAttribute('data-more') || 'Read More') : (rm.getAttribute('data-less') || 'Read Less'); }
      return;
    }

    if (search && search.classList.contains('is-open') && !e.target.closest('[data-mb-search]')) closeSearch();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closeSearch(); closePanels(); } });

  /* ---------------- cookie preferences (Shopify privacy banner) ---------------- */
  var cookieLinks = function () {
    if (!(w.privacyBanner && w.privacyBanner.showPreferences)) return false;
    $$('[data-mb-cookie-prefs]').forEach(function (b) { b.hidden = false; });
    return true;
  };
  if (!cookieLinks()) { var ctries = 0, ct = setInterval(function () { if (cookieLinks() || ++ctries > 20) clearInterval(ct); }, 500); }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-cookie-prefs]');
    if (b && w.privacyBanner && w.privacyBanner.showPreferences) { e.preventDefault(); w.privacyBanner.showPreferences(); }
  });

  /* ---------------- money ---------------- */
  var formatMoney = function (cents) {
    var fmt = T.moneyFormat || '£{{amount}}';
    var n = (cents / 100);
    var withDelim = function (num, dec, th, sep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(sep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelim(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(n, 0, '.', ',');
        case 'amount_with_space_separator': return withDelim(n, 2, ' ', ',');
        default: return withDelim(n, 2, ',', '.');
      }
    });
  };

  /* ---------------- cart ---------------- */
  var drawerInner = function () { return $('[data-mb-cart-drawer-inner]'); };
  var renderCart = function (sections) {
    if (!sections) return;
    var html = sections['mb-cart-drawer'];
    if (html) {
      var tmp = d.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-mb-cart-drawer-inner]', tmp), cur = drawerInner();
      if (fresh && cur) cur.replaceWith(fresh);
    }
  };
  var updateCount = function (count) {
    $$('[data-mb-cart-count]').forEach(function (el) { el.hidden = !count; var s = $('span', el); if (s) s.textContent = count; });
  };
  var refreshCount = function () { return fetch(root + '/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; }); };
  var cartAdd = function (items) {
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'mb-cart-drawer', sections_url: w.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) { renderCart(j.sections); return refreshCount().then(function () { openDrawer('cart'); return j; }); });
  };
  var cartChange = function (key, qty, el) {
    if (el) el.classList.add('is-loading');
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: 'mb-cart-drawer', sections_url: w.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      renderCart(j.sections); updateCount(j.item_count);
      if ($('[data-mb-cart-page]')) w.location.reload();
    }).catch(function () { if (el) el.classList.remove('is-loading'); });
  };
  w.MB.cartAdd = cartAdd;

  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-mb-qty-change]');
    if (q) {
      var line = q.closest('[data-key]');
      if (!line) return;
      e.preventDefault();
      cartChange(line.getAttribute('data-key'), parseInt(q.getAttribute('data-mb-qty-change'), 10), line);
      return;
    }
    var qa = e.target.closest('[data-mb-quick-add]');
    if (qa) {
      e.preventDefault();
      qa.disabled = true;
      cartAdd([{ id: parseInt(qa.getAttribute('data-mb-quick-add'), 10), quantity: 1 }]).catch(function () {}).then(function () { qa.disabled = false; });
    }
  });
  d.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-mb-qty-input]');
    if (inp) { var line = inp.closest('[data-key]'); if (line && !$('[data-mb-cart-page]')) cartChange(line.getAttribute('data-key'), parseInt(inp.value, 10) || 0, line); return; }
    var note = e.target.closest('[data-mb-cart-note]');
    if (note) { fetch((T.routes.cartUpdate || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); }
  });
  d.addEventListener('submit', function (e) {
    var disc = e.target.closest('[data-mb-discount]');
    if (disc) {
      e.preventDefault();
      var code = (disc.querySelector('input').value || '').trim();
      if (!code) return;
      fetch(root + '/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { return fetch(root + '/?sections=mb-cart-drawer'); })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
    }
  });

  /* ---------------- product page ---------------- */
  var ELLIPSIS_H = 175;
  var setupEllipsis = function (el) {
    if (!el || el._mb) return;
    el._mb = true;
    var content = $('.mb-ellipsis__content', el);
    if (content.scrollHeight > ELLIPSIS_H) { el.classList.add('is-enabled'); el.style.height = ELLIPSIS_H + 'px'; }
  };
  w.MB.setupEllipsis = setupEllipsis;

  var initUpsell = function (box) {
    var track = $('[data-mb-upsell-track]', box), dots = $('[data-mb-upsell-dots]', box);
    var cells = $$('.mb-pupsell__cell', track), n = cells.length, idx = 0, sx = null, sy = null, moved = false, base = 0;
    if (!n) { box.hidden = true; return; }
    box.hidden = false;
    var step = function () { return cells[0].getBoundingClientRect().width + 12; };
    var go = function (i) {
      idx = Math.max(0, Math.min(n - 1, i)); base = -idx * step();
      track.style.transform = 'translateX(' + base + 'px)';
      $$('.mb-dot', dots).forEach(function (dt, k) { dt.classList.toggle('is-selected', k === idx); dt.setAttribute('aria-current', k === idx); });
    };
    dots.innerHTML = n > 1 ? cells.map(function (c, i) { return '<button class="mb-dot' + (i ? '' : ' is-selected') + '" type="button" aria-label="' + (i + 1) + ' / ' + n + '"></button>'; }).join('') : '';
    dots.addEventListener('click', function (e) { var bt = e.target.closest('.mb-dot'); if (bt) go($$('.mb-dot', dots).indexOf(bt)); });
    if (n > 1) {
      track.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; sx = e.clientX; sy = e.clientY; moved = false; });
      w.addEventListener('pointermove', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(e.clientY - sy)) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.style.transform = 'translateX(' + (base + dx) + 'px)';
      });
      w.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx; sx = null; track.classList.remove('is-dragging');
        if (moved && Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); else go(idx);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      w.addEventListener('resize', function () { go(idx); });
    }
  };

  var zoomViewer = null;
  var openZoom = function (links, start) {
    if (zoomViewer) zoomViewer.remove();
    var n = links.length, idx = start, scale = 1, lastFocus = d.activeElement;
    var z = d.createElement('div');
    z.className = 'mb-zoom'; z.setAttribute('role', 'dialog'); z.setAttribute('aria-modal', 'true'); z.setAttribute('aria-label', (T.strings && T.strings.imageViewer) || 'Image viewer');
    z.innerHTML = '<div class="mb-zoom__track">' + links.map(function (a) { var gi = $('img', a) || {}; return '<div class="mb-zoom__slide"><img alt="' + (gi.alt || '').replace(/"/g, '&quot;') + '" data-src="' + a.href + '" data-low="' + (gi.currentSrc || gi.src || '') + '" draggable="false"></div>'; }).join('') + '</div>' +
      '<button class="mb-zoom__close" type="button" aria-label="' + ((T.strings && T.strings.close) || 'Close') + '"><svg class="mb-icon"><use href="#i-close"/></svg></button>' +
      (n > 1 ? '<button class="mb-zoom__arrow mb-zoom__arrow--prev" type="button" aria-label="' + ((T.strings && T.strings.previous) || 'Previous') + '"><svg class="mb-icon"><use href="#i-arrow-r"/></svg></button><button class="mb-zoom__arrow mb-zoom__arrow--next" type="button" aria-label="' + ((T.strings && T.strings.next) || 'Next') + '"><svg class="mb-icon"><use href="#i-arrow-r"/></svg></button>' : '');
    d.body.appendChild(z); zoomViewer = z;
    var track = $('.mb-zoom__track', z), slides = $$('.mb-zoom__slide', z);
    var load = function (i) {
      var im = slides[i] && $('img', slides[i]);
      if (!im || im._mb) return;
      im._mb = true;
      var hi = im.getAttribute('data-src'), low = im.getAttribute('data-low');
      if (low) im.src = low;
      var pre = new Image();
      pre.onload = function () { im.src = hi; };
      pre.src = hi;
      if (!low) im.src = hi;
    };
    var resetZoom = function () { slides.forEach(function (sl) { sl.classList.remove('is-zoomed'); var im = $('img', sl); im.style.transform = ''; }); scale = 1; };
    var show = function (i, anim) {
      idx = (i + n) % n; resetZoom();
      track.style.transition = anim ? '' : 'none';
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      load(idx); load((idx + 1) % n); load((idx - 1 + n) % n);
    };
    var close = function () {
      z.classList.remove('is-open'); d.documentElement.classList.remove('mb-zoom-open');
      d.removeEventListener('keydown', onKey);
      setTimeout(function () { z.remove(); if (zoomViewer === z) zoomViewer = null; }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    var onKey = function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
      else if (e.key === 'ArrowRight' && n > 1) show(idx + 1, true);
      else if (e.key === 'ArrowLeft' && n > 1) show(idx - 1, true);
    };
    d.addEventListener('keydown', onKey);
    $('.mb-zoom__close', z).addEventListener('click', close);
    if (n > 1) {
      $('.mb-zoom__arrow--prev', z).addEventListener('click', function () { show(idx - 1, true); });
      $('.mb-zoom__arrow--next', z).addEventListener('click', function () { show(idx + 1, true); });
    }
    var sx = null, sy = null, dragged = false;
    track.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; dragged = false; });
    track.addEventListener('pointermove', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx;
      if (scale > 1) {
        var im = $('img', slides[idx]), r = slides[idx].getBoundingClientRect();
        im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        return;
      }
      if (!dragged && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - sy)) { dragged = true; track.classList.add('is-dragging'); }
      if (dragged) track.style.transform = 'translateX(calc(' + (-idx * 100) + '% + ' + dx + 'px))';
    });
    track.addEventListener('mousemove', function (e) {
      if (scale === 1) return;
      var im = $('img', slides[idx]), r = slides[idx].getBoundingClientRect();
      im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    var endDrag = function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx; sx = null; track.classList.remove('is-dragging');
      if (dragged) { if (n > 1 && Math.abs(dx) > 60) show(idx + (dx < 0 ? 1 : -1), true); else show(idx, true); return; }
      var im = e.target.closest('.mb-zoom__slide img');
      if (im) {
        var sl = im.parentNode, r = im.getBoundingClientRect();
        if (scale === 1) { scale = 2; im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; im.style.transform = 'scale(2)'; sl.classList.add('is-zoomed'); }
        else resetZoom();
      } else if (e.target.classList.contains('mb-zoom__slide') && scale === 1) close();
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', function () { sx = null; track.classList.remove('is-dragging'); show(idx, true); });
    show(start, false);
    d.documentElement.classList.add('mb-zoom-open');
    w.requestAnimationFrame(function () { z.classList.add('is-open'); $('.mb-zoom__close', z).focus({ preventScroll: true }); });
  };

  $$('[data-mb-product]').forEach(function (sec) {
    var form = $('[data-mb-product-form]', sec);
    var jsonEl = $('[data-mb-product-json]', sec);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var idInput = form && $('[data-mb-variant-id]', form);
    var addBtn = form && $('[data-mb-add]', form);
    var priceRow = $('[data-mb-price]', sec);
    var gallery = $('[data-mb-gallery]', sec);
    var thumbs = $('[data-mb-thumbs]', sec);
    var errorEl = form && $('[data-mb-error]', form);
    var pinfo = $('[data-mb-pinfo]', sec);
    var addon = $('[data-mb-addon]', sec);
    var bar = $('[data-mb-cartbar]', sec);
    var barBtn = bar && $('[data-mb-cartbar-add]', bar);

    var currentOptions = function () {
      return $$('[data-mb-option]', sec).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    };
    var findVariant = function (opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; }); })[0];
    };
    var curVariant = (idInput && data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0]) || data.variants[0];

    var addonPrice = function () { var o = addon && $('.mb-addon__opt.is-active', addon); return o ? (parseInt(o.getAttribute('data-price'), 10) || 0) : 0; };
    var renderPrice = function () {
      if (!curVariant) return;
      var extra = addonPrice(), total = curVariant.price + extra;
      if (priceRow) priceRow.innerHTML = '<span class="mb-pprice__now">' + (extra ? formatMoney(total) : curVariant.priceText) + '</span>' + (curVariant.compare && !extra ? '<s class="mb-pprice__was">' + curVariant.compare + '</s>' : '');
      var bp = bar && $('[data-mb-cartbar-price]', bar); if (bp) bp.textContent = extra ? formatMoney(total) : curVariant.priceText;
    };
    var setButtons = function (available, unavailable) {
      var txt = unavailable ? (T.strings.unavailable || 'Unavailable') : available ? (T.strings.addToCart || 'Add to basket') : (T.strings.soldOut || 'Sold out');
      [addBtn, barBtn].forEach(function (bt) { if (!bt) return; bt.disabled = !available; bt.querySelector('span').textContent = txt; });
    };

    var slides = function () { return gallery ? $$('.mb-pmedia', gallery) : []; };
    var galleryIndex = function () {
      var items = slides(), gl = gallery.scrollLeft, idx = 0, best = 1e9;
      items.forEach(function (it, i) { var dlt = Math.abs(it.offsetLeft - gallery.offsetLeft - gl); if (dlt < best) { best = dlt; idx = i; } });
      return idx;
    };
    var scrollGalleryTo = function (index, smooth) {
      if (!gallery) return;
      var it = slides()[index];
      if (!it) return;
      gallery.scrollTo({ left: it.offsetLeft - gallery.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    var updateAvailability = function () {
      var opts = currentOptions();
      $$('[data-mb-option]', sec).forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var any = data.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
          inp.parentNode.classList.toggle('is-unavailable', !any);
        });
      });
    };
    var onVariant = function () {
      var v = findVariant(currentOptions());
      if (!v) { setButtons(false, true); return; }
      curVariant = v;
      if (idInput) idInput.value = v.id;
      renderPrice();
      setButtons(v.available, false);
      if (bar && v.image) { var bi = $('[data-mb-cartbar-img]', bar); if (bi) { bi.removeAttribute('srcset'); bi.src = v.image; } }
      if (v.media && gallery) {
        var target = $('[data-media-id="' + v.media + '"]', gallery);
        if (target) scrollGalleryTo(slides().indexOf(target), true);
      }
      var url = new URL(w.location.href); url.searchParams.set('variant', v.id); w.history.replaceState({}, '', url.toString());
      updateAvailability();
    };
    $$('[data-mb-option] input', sec).forEach(function (inp) { inp.addEventListener('change', onVariant); });
    updateAvailability();
    // colour swatches that link to the same lamp in another colour (a separate product page): each link's href carries the
    // chosen size (?variant=), so a click, a new tab or a copied link all open the same size in the other colour
    var sibLinks = $$('[data-mb-sibling]', sec).filter(function (a) { return !a.getAttribute('aria-current'); });
    var syncSiblings = function () {
      var key = currentOptions().join(' / ');
      sibLinks.forEach(function (a) {
        var map = {};
        try { map = JSON.parse(a.getAttribute('data-variants') || '{}'); } catch (err) { /* keep the plain link */ }
        var base = a.getAttribute('href').split('?')[0];
        a.setAttribute('href', map[key] ? base + '?variant=' + map[key] : base);
      });
    };
    if (sibLinks.length) {
      $$('[data-mb-option] input', sec).forEach(function (inp) { inp.addEventListener('change', syncSiblings); });
      syncSiblings();
    }
    $$('[data-mb-sibling][aria-current]', sec).forEach(function (a) {
      a.addEventListener('click', function (e) { if (!(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button)) e.preventDefault(); });
    });

    var qty = $('[data-mb-qty]', sec);
    if (qty) {
      var qi = $('input', qty);
      $('.mb-qty__minus', qty).addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
      $('.mb-qty__plus', qty).addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; });
    }

    if (addon) {
      var at = $('.mb-addon__toggle', addon), av = $('[data-mb-addon-value]', addon), aid = $('[data-mb-addon-id]', addon), amedia = $('[data-mb-addon-media]', addon);
      var setOpen = function (o) { addon.classList.toggle('is-open', o); at.setAttribute('aria-expanded', o); };
      at.addEventListener('click', function () { setOpen(!addon.classList.contains('is-open')); });
      $$('.mb-addon__opt', addon).forEach(function (opt) {
        opt.addEventListener('click', function () {
          $$('.mb-addon__opt', addon).forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
          opt.classList.add('is-active'); opt.setAttribute('aria-selected', 'true');
          aid.value = opt.getAttribute('data-variant') || '';
          av.textContent = opt.getAttribute('data-label');
          var m = $('.mb-addon__media', opt); if (m && amedia) amedia.innerHTML = m.innerHTML;
          setOpen(false); at.focus();
          renderPrice();
        });
      });
      d.addEventListener('click', function (e) { if (!addon.contains(e.target)) setOpen(false); });
      addon.addEventListener('keydown', function (e) { if (e.key === 'Escape' && addon.classList.contains('is-open')) { e.stopPropagation(); setOpen(false); at.focus(); } });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput || !idInput.value) return;
        var q = parseInt((form.querySelector('input[name="quantity"]') || { value: 1 }).value, 10) || 1;
        var items = [{ id: parseInt(idInput.value, 10), quantity: q }];
        var addonId = addon && $('[data-mb-addon-id]', addon).value;
        if (addonId) items.push({ id: parseInt(addonId, 10), quantity: q * (parseInt(addon.getAttribute('data-count'), 10) || 1) });
        if (errorEl) errorEl.hidden = true;
        var btns = [addBtn, barBtn].filter(Boolean), olds = btns.map(function (bt) { return bt.querySelector('span').textContent; });
        btns.forEach(function (bt) { bt.disabled = true; bt.querySelector('span').textContent = T.strings.adding || 'Adding'; });
        cartAdd(items).catch(function (err) {
          if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || T.strings.cartError; errorEl.hidden = false; }
        }).then(function () { btns.forEach(function (bt, i) { bt.disabled = false; bt.querySelector('span').textContent = olds[i]; }); });
      });
    }

    /* gallery: thumbnails, arrows, full screen viewer */
    if (thumbs && gallery) {
      $$('a', thumbs).forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); scrollGalleryTo(parseInt(a.getAttribute('data-index'), 10), true); });
      });
      var setActive = function () {
        var idx = galleryIndex();
        $$('.mb-pthumb', thumbs).forEach(function (t, i) {
          t.classList.toggle('is-active', i === idx);
          if (i === idx) { var tl = t.offsetLeft - thumbs.offsetLeft; if (tl < thumbs.scrollLeft || tl + t.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: Math.max(0, tl - 15), behavior: 'smooth' }); }
        });
      };
      gallery.addEventListener('scroll', function () { w.requestAnimationFrame(setActive); }, { passive: true });
    }
    var gp = $('[data-mb-gallery-prev]', sec), gn = $('[data-mb-gallery-next]', sec);
    if (gallery && gp && gn) {
      gp.addEventListener('click', function () { var n = slides().length; scrollGalleryTo((galleryIndex() - 1 + n) % n, true); });
      gn.addEventListener('click', function () { var n = slides().length; scrollGalleryTo((galleryIndex() + 1) % n, true); });
    }
    var zoomLinks = $$('[data-mb-zoom]', sec);
    zoomLinks.forEach(function (a, i) { a.addEventListener('click', function (e) { e.preventDefault(); openZoom(zoomLinks, i); }); });
    $$('.mb-pmedia:not([data-mb-zoom])', sec).forEach(function (a) { if (a.tagName === 'A') a.addEventListener('click', function (e) { e.preventDefault(); }); });

    /* info column: sticky in both scroll directions when it is taller than the screen */
    if (pinfo) {
      var lastY = w.scrollY, prevTop = pinfo.getBoundingClientRect().top, ticking = false;
      var headerH = function () { return parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--mb-header-h')) || 61; };
      var stick = function () {
        ticking = false;
        var y = w.scrollY, dy = y - lastY; lastY = y;
        if (!mq('(min-width:768px)')) { pinfo.style.top = ''; prevTop = pinfo.getBoundingClientRect().top; return; }
        var top0 = headerH(), minTop = w.innerHeight - pinfo.offsetHeight - 30;
        var t = minTop >= top0 ? top0 : Math.min(top0, Math.max(minTop, prevTop - dy));
        pinfo.style.top = t + 'px';
        prevTop = pinfo.getBoundingClientRect().top;
      };
      w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(stick); } }, { passive: true });
      w.addEventListener('resize', function () { prevTop = pinfo.getBoundingClientRect().top; stick(); });
      stick();
    }

    /* sticky add-to-basket bar */
    if (bar) {
      d.body.appendChild(bar);
      if (pinfo) {
        var barTick = false;
        var barCheck = function () { barTick = false; bar.classList.toggle('is-visible', pinfo.getBoundingClientRect().bottom < 0); };
        w.addEventListener('scroll', function () { if (!barTick) { barTick = true; w.requestAnimationFrame(barCheck); } }, { passive: true });
        w.addEventListener('resize', barCheck);
        barCheck();
      }
      if (barBtn) barBtn.addEventListener('click', function () { if (!form || barBtn.disabled) return; if (form.requestSubmit) form.requestSubmit(); else if (addBtn) addBtn.click(); });
    }

    /* shop the look */
    $$('[data-mb-upsell]', sec).forEach(function (box) {
      var url = box.getAttribute('data-mb-upsell-url');
      if (!url) { initUpsell(box); return; }
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var reco = $('[data-mb-upsell-reco]', tmp);
        if (reco && reco.innerHTML.trim()) { $('[data-mb-upsell-track]', box).innerHTML = reco.innerHTML; initUpsell(box); }
      }).catch(function () {});
    });

    /* accessories: one select per option; price + photo follow the choice; Add puts that variant in the basket */
    $$('[data-mb-xs]', sec).forEach(function (row) {
      var vs = [], imgs = [];
      try { vs = JSON.parse($('[data-mb-xs-json]', row).textContent); imgs = JSON.parse(row.getAttribute('data-imgs') || '[]'); } catch (e) {}
      var sels = $$('[data-mb-xs-opt]', row), price = $('[data-mb-xs-price]', row), img = $('[data-mb-xs-img]', row), add = $('[data-mb-xs-add]', row);
      var txt = add.querySelector('span'), label = txt.textContent;
      var pick = function () {
        if (!sels.length) return vs[0];
        var want = sels.map(function (sl) { return sl.value; }).join('|');
        for (var i = 0; i < vs.length; i++) if (vs[i][1] === want) return vs[i];
        return null;
      };
      var update = function () {
        var v = pick();
        add.disabled = !v || !v[3];
        txt.textContent = v && v[3] ? label : (v ? T.strings.soldOut : T.strings.unavailable) || label;
        if (!v) return;
        add.setAttribute('data-mb-xs-add', v[0]);
        if (price) price.textContent = formatMoney(v[2]);
        if (img && v[4] >= 0 && imgs[v[4]]) { img.removeAttribute('srcset'); img.src = imgs[v[4]]; }
      };
      sels.forEach(function (sl) { sl.addEventListener('change', update); });
      if (sels.length) update();
      add.addEventListener('click', function () {
        var id = parseInt(add.getAttribute('data-mb-xs-add'), 10);
        if (!id || add.disabled) return;
        add.disabled = true; row.classList.add('is-loading'); txt.textContent = T.strings.adding || label;
        cartAdd([{ id: id, quantity: 1 }]).catch(function () {}).then(function () { add.disabled = false; row.classList.remove('is-loading'); txt.textContent = label; });
      });
    });

    /* accessories slider: arrows + dots follow the native swipe/scroll */
    $$('[data-mb-pxs]', sec).forEach(function (box) {
      var track = $('[data-mb-pxs-track]', box), cards = $$('.mb-xs', track), dots = $('[data-mb-pxs-dots]', box);
      var prev = $('[data-mb-pxs-prev]', box), next = $('[data-mb-pxs-next]', box);
      if (cards.length < 2 || !dots) return;
      dots.innerHTML = cards.map(function (c, i) { return '<button class="mb-dot' + (i ? '' : ' is-selected') + '" type="button" aria-label="' + (i + 1) + ' / ' + cards.length + '"></button>'; }).join('');
      var current = function () { var best = 0, bd = 1e9; cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - track.scrollLeft); if (dd < bd) { bd = dd; best = i; } }); return best; };
      var go = function (i) { i = Math.max(0, Math.min(cards.length - 1, i)); track.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' }); };
      var sync = function () {
        var i = current(), end = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (end) i = cards.length - 1;
        $$('.mb-dot', dots).forEach(function (dt, k) { dt.classList.toggle('is-selected', k === i); dt.setAttribute('aria-current', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === cards.length - 1;
      };
      dots.addEventListener('click', function (e) { var bt = e.target.closest('.mb-dot'); if (bt) go($$('.mb-dot', dots).indexOf(bt)); });
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      track.addEventListener('scroll', function () { w.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  });

  /* "Show less" at the end of an opened <details> (highlight box on the product page) */
  d.addEventListener('click', function (e) {
    var c = e.target.closest('[data-mb-details-close]'); if (!c) return;
    var det = c.closest('details'); if (!det) return;
    det.open = false;
    var sm = det.querySelector('summary');
    if (sm) { sm.focus({ preventScroll: true }); if (sm.getBoundingClientRect().top < 80) sm.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  });

  /* ---------------- in your home: photo row under the product ---------------- */
  $$('[data-mb-iyh]').forEach(function (sec) {
    var track = $('[data-mb-iyh-track]', sec), prev = $('[data-mb-iyh-prev]', sec), next = $('[data-mb-iyh-next]', sec);
    if (!track || !prev || !next) return;
    var step = function () { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 300; };
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max;
      sec.classList.toggle('is-static', max <= 0);
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { w.requestAnimationFrame(sync); }, { passive: true });
    w.addEventListener('resize', sync);
    sync();
  });

  /* ---------------- recommendations (bought together, related) ---------------- */
  var initFbt = function (box) {
    var total = $('[data-mb-fbt-total]', box);
    var recalc = function () {
      var sum = 0;
      $$('.mb-fbt__item', box).forEach(function (it) { var c = $('[data-mb-fbt-check]', it); if (c && c.checked) sum += parseInt(it.getAttribute('data-price'), 10) || 0; });
      if (total) total.textContent = formatMoney(sum);
    };
    $$('[data-mb-fbt-check]', box).forEach(function (c) { c.addEventListener('change', recalc); });
    var btn = $('[data-mb-fbt-add]', box);
    if (btn) btn.addEventListener('click', function () {
      var items = $$('.mb-fbt__item', box).filter(function (it) { var c = $('[data-mb-fbt-check]', it); return c && c.checked; })
        .map(function (it) { return { id: parseInt(it.getAttribute('data-variant'), 10), quantity: 1 }; });
      if (!items.length) return;
      btn.disabled = true;
      cartAdd(items).catch(function () {}).then(function () { btn.disabled = false; });
    });
  };
  $$('[data-mb-recs]').forEach(function (sec) {
    var url = sec.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = d.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-mb-recs]', tmp);
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; $$('[data-mb-carousel]', sec).forEach(initCarousel); $$('[data-mb-fbt]', sec).forEach(initFbt); }
      else sec.style.display = 'none';
    }).catch(function () { sec.style.display = 'none'; });
  });

  /* ---------------- collection filters + sort ---------------- */
  var closePanels = function () {
    $$('[data-mb-fopt].is-open, [data-mb-sort].is-open').forEach(function (p) { p.classList.remove('is-open'); var b = $('button', p); if (b) b.setAttribute('aria-expanded', 'false'); });
  };
  var collectionUpdate = function (url, push) {
    var sec = $('[data-mb-collection]');
    if (!sec) { w.location.href = url; return; }
    var sid = sec.getAttribute('data-section-id');
    var u = new URL(url, w.location.origin); u.searchParams.set('section_id', sid);
    sec.classList.add('is-loading');
    fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = d.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-mb-collection]', tmp);
      if (fresh) { sec.replaceWith(fresh); bindCollection(); }
      var clean = new URL(url, w.location.origin); clean.searchParams.delete('section_id');
      if (push) w.history.pushState({ mbFilter: true }, '', clean.toString());
      closeDrawers();
    }).catch(function () { w.location.href = url; });
  };
  var formUrl = function (form) {
    var fd = new FormData(form), params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    return form.getAttribute('action') + '?' + params.toString();
  };
  var bindCollection = function () {
    /* the filter drawer lives inside the section; move it to <body> so it stacks above the overlay */
    $$('body > [data-mb-drawer="filters"]').forEach(function (x) { x.remove(); });
    var fdr = $('[data-mb-collection] [data-mb-drawer="filters"]');
    if (fdr) d.body.appendChild(fdr);
    $$('[data-mb-fopt]').forEach(function (opt) {
      var btn = $('.mb-fopt__btn', opt);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = opt.classList.contains('is-open'); closePanels();
        opt.classList.toggle('is-open', !was); btn.setAttribute('aria-expanded', !was);
      });
    });
    $$('[data-mb-sort]').forEach(function (s) {
      var btn = $('.mb-sort__btn', s);
      btn.addEventListener('click', function (e) { e.stopPropagation(); var was = s.classList.contains('is-open'); closePanels(); s.classList.toggle('is-open', !was); btn.setAttribute('aria-expanded', !was); });
      $$('[data-mb-sort-value]', s).forEach(function (o) {
        o.addEventListener('click', function () {
          var form = $('[data-mb-fbar]'); if (!form) return;
          $('[data-mb-sort-input]', form).value = o.getAttribute('data-mb-sort-value');
          collectionUpdate(formUrl(form), true);
        });
      });
    });
    var fbar = $('[data-mb-fbar]');
    if (fbar) {
      fbar.addEventListener('change', function (e) { if (e.target.type === 'checkbox') collectionUpdate(formUrl(fbar), true); });
      fbar.addEventListener('submit', function (e) { e.preventDefault(); collectionUpdate(formUrl(fbar), true); });
    }
    var dform = $('[data-mb-fdrawer-form]');
    if (dform) {
      dform.addEventListener('submit', function (e) { e.preventDefault(); collectionUpdate(formUrl(dform), true); });
      $$('[data-mb-fpane]', dform).forEach(function (row) {
        row.addEventListener('click', function () {
          var body = $('[data-mb-fpane-body="' + row.getAttribute('data-mb-fpane') + '"]', dform);
          var open = !body.classList.contains('is-open');
          $$('.mb-fdrawer__pane', dform).forEach(function (p) { p.classList.remove('is-open'); });
          body.classList.toggle('is-open', open);
          dform.classList.toggle('has-pane', open);
        });
      });
      var back = $('[data-mb-fpane-back]', dform);
      if (back) back.addEventListener('click', function () {
        var openPane = $('.mb-fdrawer__pane.is-open', dform);
        if (openPane) { openPane.classList.remove('is-open'); dform.classList.remove('has-pane'); } else closeDrawers();
      });
    }
    $$('[data-mb-carousel]').forEach(function (c) { if (!c._mb) initCarousel(c); });
  };
  d.addEventListener('click', function (e) { if (!e.target.closest('[data-mb-fopt], [data-mb-sort]')) closePanels(); });
  w.addEventListener('popstate', function (e) { if (e.state && e.state.mbFilter || $('[data-mb-collection]')) collectionUpdate(w.location.href, false); });

  /* ---------------- pills scroll shadows ---------------- */
  $$('[data-mb-pills]').forEach(function (p) {
    var tr = $('.mb-pills__track', p), l = $('.mb-pills__shadow--l', p), r = $('.mb-pills__shadow--r', p);
    var upd = function () { var max = tr.scrollWidth - tr.clientWidth; l.style.opacity = tr.scrollLeft > 2 ? 1 : 0; r.style.opacity = tr.scrollLeft < max - 2 ? 1 : 0; };
    tr.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
  });

  /* ---------------- press logos ---------------- */
  $$('[data-mb-press]').forEach(function (box) {
    var cells = $$('.mb-press__logo', box), n = cells.length, active = 0, startX = null;
    if (!n) return;
    var dotsBox = $('[data-mb-press-dots]', box), dots = [];
    var layout = function (anim) {
      var W = box.getBoundingClientRect().width, cw = 200, sliding = n * cw > W;
      cells.forEach(function (c, i) {
        var x;
        if (!sliding) x = (W - n * cw) / 2 + i * cw;
        else { var off = i - active; if (off > n / 2) off -= n; else if (off < -n / 2) off += n; x = (W - cw) / 2 + off * cw; }
        c.style.transition = anim ? '' : 'none';
        c.style.transform = 'translateX(' + x + 'px)';
      });
      if (!dotsBox) return;
      if (sliding && !dots.length) {
        cells.forEach(function (c, i) {
          var b = d.createElement('button');
          b.type = 'button'; b.className = 'mb-press__dot'; b.setAttribute('aria-label', String(i + 1));
          b.addEventListener('click', function () { active = i; layout(true); });
          dotsBox.appendChild(b); dots.push(b);
        });
      } else if (!sliding && dots.length) { dotsBox.innerHTML = ''; dots = []; }
      dots.forEach(function (b, i) { b.classList.toggle('is-selected', i === active); });
    };
    box.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    w.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX; startX = null;
      if (Math.abs(dx) > 30 && n * 200 > box.getBoundingClientRect().width) { active = (active + (dx < 0 ? 1 : -1) + n) % n; layout(true); }
    });
    w.addEventListener('resize', function () { layout(false); });
    layout(false);
  });

  /* ---------------- reviews carousel ---------------- */
  $$('[data-mb-reviews]').forEach(function (rv) {
    var track = $('.mb-reviews__track', rv), prev = $('.mb-reviews__btn--prev', rv), next = $('.mb-reviews__btn--next', rv), vp = $('.mb-reviews__viewport', rv);
    if (!track) return;
    var idx = 0, sx = null;
    var per = function () { var c = track.children[0]; if (!c) return 1; return Math.max(1, Math.round((vp.getBoundingClientRect().width + 10) / (c.getBoundingClientRect().width + 10))); };
    var update = function () {
      var c = track.children[0]; if (!c) return;
      var maxI = Math.max(0, track.children.length - per());
      idx = Math.min(Math.max(idx, 0), maxI);
      track.style.transform = 'translateX(' + (-idx * (c.getBoundingClientRect().width + 10)) + 'px)';
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx >= maxI;
    };
    if (prev) prev.addEventListener('click', function () { idx--; update(); });
    if (next) next.addEventListener('click', function () { idx++; update(); });
    vp.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    vp.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) { idx += dx < 0 ? 1 : -1; update(); } });
    w.addEventListener('resize', update);
    update();
  });

  /* ---------------- product carousels (drag on desktop, native swipe on mobile) ---------------- */
  function initCarousel(car) {
    car._mb = true;
    var track = $('.mb-carousel__track', car);
    if (!track) return;
    var pos = 0, startX = 0, startPos = 0, dragging = false, moved = false;
    var desktop = function () { return mq('(min-width:768px)'); };
    var step = function () { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 20 : 0; };
    var max = function () { var n = track.children.length, s = step(); if (!s) return 0; var vis = Math.floor((car.getBoundingClientRect().width - 40 + 20) / s + 0.01); return Math.max(0, (n - vis) * s); };
    var apply = function (anim) { track.style.transition = anim ? '' : 'none'; track.style.transform = 'translateX(' + (-pos) + 'px)'; };
    track.addEventListener('pointerdown', function (e) { if (!desktop() || e.button !== 0) return; dragging = true; moved = false; startX = e.clientX; startPos = pos; });
    w.addEventListener('pointermove', function (e) { if (!dragging) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; pos = Math.min(max(), Math.max(0, startPos - dx)); apply(false); });
    w.addEventListener('pointerup', function () { if (!dragging) return; dragging = false; var s = step(); pos = Math.min(max(), Math.max(0, Math.round(pos / s) * s)); apply(true); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    w.addEventListener('resize', function () { if (!desktop()) { pos = 0; track.style.transform = ''; } else { pos = Math.min(pos, max()); apply(false); } });
  }
  $$('[data-mb-carousel]').forEach(initCarousel);
  bindCollection();

  /* ---------------- card colour dots: hovering a dot shows that colour's photo in the card ---------------- */
  var cardMainImg = function (card) { return card && card.querySelector('.mb-gcard__img img:not(.mb-gcard__img2), .mb-card__img img:not(.mb-card__img2)'); };
  d.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.mb-cswatch[data-img]');
    if (!dot) return;
    var card = dot.closest('.mb-gcard, .mb-card'), img = cardMainImg(card);
    if (!img) return;
    if (!img.hasAttribute('data-orig')) { img.setAttribute('data-orig', img.currentSrc || img.src); img.setAttribute('data-orig-set', img.getAttribute('srcset') || ''); }
    img.removeAttribute('srcset'); img.src = dot.getAttribute('data-img');
    card.classList.add('is-swatching');
  });
  d.addEventListener('mouseout', function (e) {
    var wrap = e.target.closest && e.target.closest('[data-mb-cswatches]');
    if (!wrap || (e.relatedTarget && wrap.contains(e.relatedTarget))) return;
    var card = wrap.closest('.mb-gcard, .mb-card'), img = cardMainImg(card);
    if (img && img.hasAttribute('data-orig')) {
      if (img.getAttribute('data-orig-set')) img.setAttribute('srcset', img.getAttribute('data-orig-set'));
      img.src = img.getAttribute('data-orig');
    }
    if (card) card.classList.remove('is-swatching');
  });

  /* ---------------- theme editor ---------------- */
  d.addEventListener('shopify:section:load', function () { w.location.reload(); });
})();
